var Interface = require('../core');
var _ = require('lodash');

Interface
  .postprocessor('side-load-lookup', {
    // TODO does this work with arrays and objects like below (see the _.map)
    convertToSource: function convertToSource(sync, req) {
      return (_.isString(req.hint.idKey))
        ? sync[req.hint.idKey]
        : sync;
    },

    /** */
    convertToSync: function convertToSync(sync, req, dtdQueue) {

      var rootDtd = dtdQueue[0];

      if (!!req.hint) {
        sync = (!(_.isPlainObject(sync) || _.isArray(sync)))
          ? rootDtd[req.hint.lookupKey][sync]
          : _.map(sync, function (key) {
          return rootDtd[req.hint.lookupKey][key];
        });
      }

      return sync;
    }
  });


// WEBPACK FOOTER //
// side_load_lookup.js